import qs from 'querystring';
import differenceInMinutes from 'date-fns/differenceInMinutes';
import differenceInHours from 'date-fns/differenceInHours';

import toDate from '../toDate';

import formatCalendarDate from './formatCalendarDate';

function formatDuration(start, end) {
  const startDate = toDate(start);
  const endDate = toDate(end);
  if (!startDate || !endDate) return null;

  const hours = differenceInHours(endDate, startDate);
  const minutes = differenceInMinutes(endDate, startDate) % 60;
  return `${hours.toString().padStart(2, '0')}${minutes.toString().padStart(2, '0')}`;
}

export default function buildYahooCalendarUrl(calendarEvent) {
  const params = {
    v: '60',
    view: 'd',
    type: '20',
    st: formatCalendarDate(calendarEvent.startTime),
    dur: formatDuration(calendarEvent.startTime, calendarEvent.endTime),
    title: calendarEvent.title,
    desc: calendarEvent.description,
    in_loc: calendarEvent.location,
    url: calendarEvent.url,
  };
  return `https://calendar.yahoo.com/?${qs.stringify(params)}`;
}
